import api from '@common/api';

export const getMenuList = () => {
  return api.get('/user/acl/menu');
};
